import { HttpInterceptorFn } from '@angular/common/http';
import { DOCS_AI_CONFIG, isOcrUrl } from '../config/docs-ai.config';

/** Attach DocsAI x-tenant-id / x-user-id on every /ocr/v1 request. */
export const ocrInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isOcrUrl(req.url)) {
    return next(req);
  }

  const { tenantId, userId } = DOCS_AI_CONFIG;
  if (!tenantId || !userId) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: {
        'x-tenant-id': tenantId,
        'x-user-id': userId,
      },
    })
  );
};
